import React from 'react';
import i18n from '@i18next/i18n';
import { NumberInput } from '@tencent/wb-ext-form';
import style from './style.less';
import { MAX_START_NUMBER, MIN_START_NUMBER, START_NUMBER_MAX_LENGTH, START_NUMBER_STEP } from '../constant';

interface Props {
    startNumber?: number;
    disabled?: boolean;
    onChange: (startNumber: number) => void;
}

export default function StartNumber(props: Props) {
    const { startNumber = 1, disabled = false, onChange } = props;
    const handleChange = (value: string) => {
        const startNumber = Number(value);
        onChange(startNumber);
    };
    return (
        <div className={style['start-number']}>
            <div className={style['start-number-label']}>
                {i18n.t('起始编号')}：
            </div>
            <div className={style['start-number-input-container']}>
                <NumberInput
                    min={MIN_START_NUMBER}
                    max={MAX_START_NUMBER}
                    maxLength={START_NUMBER_MAX_LENGTH}
                    value={`${startNumber}`}
                    step={START_NUMBER_STEP}
                    style={{ width: '70px' }}
                    disabled={disabled}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
}
